import React, { useEffect } from "react";
import "./scss/About.scss";
import logo from "../images/logo.png";
import "./scss/Home.scss";
import partnerFlowers from "../images/about/partner-flowers.png";
import partnerCall from "../images/about/partner-call.png";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();
  document.title = `Gudema - ${t("home.becomePartner")}`;

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }
    }
  }, [location]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Partner form submitted");
  };

  return (
    <main className="partner-page">
      <section className="partner-hero">
        <div className="partner-hero__container">
          <h1>{t("aboutPage.title")}</h1>

          <p>{t("aboutPage.subtitle")}</p>

          <a href="#partner-form" className="partner-hero__button">
            {t("aboutPage.questionCta")}
          </a>

          <div className="partner-hero__note">
            <span>✓</span>
            {t("aboutPage.note")}
          </div>
        </div>
      </section>

      <section className="partner-worth">
        <div className="partner-worth__content">
          <h2>{t("aboutPage.worthTitle")}</h2>

          <div className="partner-worth__text">
            <p>{t("aboutPage.worthText1")}</p>
            <p>{t("aboutPage.worthText2")}</p>
          </div>

          <ul>
            <li>{t("aboutPage.point1")}</li>
            <li>{t("aboutPage.point2")}</li>
            <li>{t("aboutPage.point3")}</li>
            <li>{t("aboutPage.point4")}</li>
          </ul>
        </div>

        <div className="partner-worth__image">
          <img src={partnerFlowers} alt={t("aboutPage.title")} />
        </div>
      </section>

      <section className="partner-form-section" id="partner-form">
        <div className="partner-form-section__container">
          <div className="partner-call-card">
            <img src={partnerCall} alt="Gudema" />

            <div className="partner-call-card__overlay">
              <h2>{t("aboutPage.callTitle")}</h2>

              <p>{t("aboutPage.callText")}</p>

              <a href="tel:+37067362767">{t("aboutPage.callNow")}</a>
            </div>
          </div>

          <form className="partner-form" onSubmit={handleSubmit}>
            <h2>{t("aboutPage.formTitle")}</h2>

            <div className="partner-form__grid">
              <input type="text" placeholder={t("common.form.firstName")} required />
              <input type="text" placeholder={t("common.form.lastName")} required />
            </div>

            <input type="text" placeholder={t("common.form.company")} />
            <input type="tel" placeholder={t("common.form.phoneRequired")} required />
            <input type="email" placeholder={t("common.form.emailRequired")} required />
            <textarea placeholder={t("common.form.messageRequired")} required />

            <label className="partner-form__terms">
              <input type="checkbox" required />

              <span>
                {t("common.form.termsStart")}{" "}
                <Link to="/privacy" target="_blank" rel="noreferrer">
                  {t("common.form.termsServices")}
                </Link>
                .
              </span>
            </label>

            <button type="submit">
              {t("aboutPage.submit")}
              <span>→</span>
            </button>
          </form>
        </div>
      </section>

      <div className="partner-cta-wrap">
        <div className="home-cta">
          <div>
            <img className="home-cta__logo" src={logo} alt="Gudema" />

            <p>{t("aboutPage.ctaText")}</p>

            <a href="#partner-form" className="home-btn home-btn--primary">
              {t("home.becomePartner")}
            </a>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;
